import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "form"
};
const _hoisted_3 = {
  class: "form-input icon5 verification"
};
const _hoisted_4 = ["disabled"];
import CustomBar from "@/components/customBar";
import { useSendCode } from "@/utils/hooks";
import { send_vcode, recover_passwd } from "@/api/index";
import { ref } from "vue";
import { router } from "@/router";

import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const params = ref({
      mobile: '',
      passwd: '',
      passwdConfirm: '',
      vcode: ''
    });
    const {
      send,
      disabled,
      sendBtnText
    } = useSendCode({
      countDownCount: 60,
      fail: msg => {
        // 手机号验证失败
        showToast(msg);
      },
      request: async mobile => {
        try {
          const res = await send_vcode({
            mobile: mobile
          });
          showToast('验证码发送成功，请注意查收');
        } catch (error) {
          showToast('验证码发送失败，请稍后重试');
        }
      }
    });
    const handleClickSend = () => send(params.value.mobile);
    const submit = () => {
      if (!params.value.mobile) return showToast('请输入账号');
      if (!params.value.passwd) return showToast('请输入密码');
      if (!params.value.passwdConfirm) return showToast('请输入确认密码');
      if (params.value.passwd != params.value.passwdConfirm) return showToast('两次密码不一致');
      if (!params.value.vcode) return showToast('请输入验证码');
      recover_passwd(params.value).then(res => {
        showToast('密码修改成功');
        setTimeout(() => {
          router.back();
        }, 1200);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "找回密码"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
        class: "form-input icon2",
        type: "tel",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.mobile = $event),
        placeholder: "请输入账号"
      }, null, 512), [[_vModelText, params.value.mobile]]), _withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.passwd = $event),
        maxlength: "12",
        placeholder: "请输入新密码（至少6位）"
      }, null, 512), [[_vModelText, params.value.passwd]]), _withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "password",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.value.passwdConfirm = $event),
        maxlength: "12",
        placeholder: "请确认新密码"
      }, null, 512), [[_vModelText, params.value.passwdConfirm]]), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
        class: "input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.value.vcode = $event),
        type: "tel",
        maxlength: "4",
        placeholder: "验证码"
      }, null, 512), [[_vModelText, params.value.vcode]]), _createElementVNode("div", {
        class: "text",
        onClick: handleClickSend,
        disabled: _unref(disabled)
      }, _toDisplayString(_unref(sendBtnText)), 9, _hoisted_4)]), _createVNode(_component_van_button, {
        type: "primary",
        large: "",
        round: "",
        block: "",
        class: "savebtn",
        onClick: submit
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("完成修改")])),
        _: 1
      })])])], 64);
    };
  }
};